import axios from 'axios'
import dayjs from 'dayjs'

import { Ordering, SearchParams } from '../home/HomePage'

const host = process.env.REACT_APP_API_HOST || 'https://wwwdev.bodc.ac.uk/data/published_data_library/api'

export const getData = async (page: number, searchParams: SearchParams, ordering: Ordering | undefined) => {
  const payload = {
    page_number: page,
    searchText: searchParams.searchText,
    authors: searchParams.authors,
    publicationYear: searchParams.publicationYear,
    temporalCoverage: searchParams.temporalCoverage,
    edmedText: searchParams.edmedText,
    ordering
  }
  const resp: any = await axios.post(`${host}/search`, payload)
  const pageCount = resp.data.metadata.totalPages
  const totalResults = resp.data.metadata.totalResults
  const results = resp.data.results.map((x: any) => ({
    title: x.title,
    authors: x.authors,
    contributors: x.contributors,
    citationType: x.citationType,
    publicationDate: dayjs(x.publicationDate),
    temporalCoverage: { start: dayjs(x.temporalCoverage.start), end: dayjs(x.temporalCoverage.end) },
    tempCoverageMasks: { start: x.temporalCoverage.startMask.toUpperCase(), end: x.temporalCoverage.endMask.toUpperCase() },
    doi: `doi:10.5285/${x.doi}`,
    edmed: x.edmed,
    edmedId: x.edmed_id
  }))
  return { pageCount, results, totalResults }
}

export function getAuthorsList (search: string) {
  return axios.get(`${host}/authors/${search}`).then(resp => {
    const results: any[] = []
    resp.data.forEach(function (x: any) {
      results.push({
        label: `${x.last_name}, ${x.first_name}`,
        value: x.iorgrf
      })
    })
    return results
  })
}
